module.exports = __webpack_public_path__ + "img/WorksWall.5731e6d5.webp";